// extracted by mini-css-extract-plugin
module.exports = {"location_container":"index-module__location_container___6Fhlv"};